/* eslint-disable react/no-danger */

type Props = {
  children: string;
  type?: string;
  defer?: boolean;
};

export function InlineScript({ children, defer, ...rest }: Props): JSX.Element {
  // Inline scripts can't be natively deferred
  const script = defer
    ? `window.addEventListener('DOMContentLoaded', () => {${children}})`
    : children;
  return (
    <script
      {...{
        type: 'application/javascript',
        ...rest,
      }}
      dangerouslySetInnerHTML={{ __html: script }}
    />
  );
}
